import { useContext } from "react"
import { PrescriptionDataContext } from "../context/PrescriptionDataContext"
const GrowerLabel = ({grower_id}) => {

    // context
    const {labelIdMap} =  useContext(PrescriptionDataContext);
    
    return (
        <span>{Object.keys(labelIdMap).includes(String(grower_id)) ? labelIdMap[grower_id] : grower_id}</span>
    )
}

export default GrowerLabel